import { errorLoading, loaded, responseHandler, errorGetStatus, tokenInterceptor } from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer
let page = 1
let maxPage = 1
let limit = 100
let isFetchingDatas = false

export const apiKeyWS = (state = { apiKeys: [], authorizations: [] }, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.API_KEY.FETCH_API_KEYS:
      return Object.assign({}, state, { apiKeys: state.apiKeys.concat(action.datas.content) })
    case Constants.ActionsConstants.API_KEY.CLEAR_API_KEYS:
      return Object.assign({}, state, { apiKeys: action.datas })
    case Constants.ActionsConstants.API_KEY.FETCH_AUTHORIZATIONS:
      return Object.assign({}, state, { authorizations: action.datas })
    default:
      return state
  }
}

export const clearApiKeys = (data) => {
  return {
    type: Constants.ActionsConstants.API_KEY.CLEAR_API_KEYS,
    datas: [],
  }
}

export const setApiKeys = (data) => {
  return {
    type: Constants.ActionsConstants.API_KEY.FETCH_API_KEYS,
    datas: data,
  }
}

export const setAuthorizations = (data) => {
  return {
    type: Constants.ActionsConstants.API_KEY.FETCH_AUTHORIZATIONS,
    datas: data,
  }
}

export function fetchApiKeyAction (dispatch, appId, apiKey) {
  function FetchAuthorizations () {
    let entryPoint = Constants.UrlsConstants.apiKeyEntryPoint
    let method = Constants.MethodsWSConstants.API_KEY.AUTHORIZATIONS
    let headers = {
      'authtoken': Constants.UrlsConstants.header.authtoken,
      'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      'Content-Type': 'application/json',
    }
    fetch(urlServer+entryPoint+method, {
      headers,
    })
      .then(response => {
        return responseHandler(response)
      })
    .then(r => r.json())
    .then(data => {
      dispatch(setAuthorizations(data))
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        fetchLogoutAction(dispatch).fetchLogout()
      }
    })
  }

  function ClearApiKeys () {
    page = 1
    maxPage = 1
    isFetchingDatas = false
    dispatch(clearApiKeys())
  }

  function GetApiKeys () {
    if (page <= maxPage && !isFetchingDatas) {
      isFetchingDatas = true
      let entryPoint = Constants.UrlsConstants.apiKeyEntryPoint
      let method = Constants.MethodsWSConstants.API_KEY.FETCH_API_KEYS
      fetch(urlServer+entryPoint+method+appId + '?sort=name&page='+page+'&size='+limit, {
        method: 'GET',
        headers: Constants.UrlsConstants.header,
      })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        maxPage = data.totalPages
        if (maxPage >= page) page++
        isFetchingDatas = false
        dispatch(setApiKeys(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
    }
  }

  function CreateApiKey () {
    let entryPoint = Constants.UrlsConstants.apiKeyEntryPoint
    let method = Constants.MethodsWSConstants.API_KEY.ADD_API_KEY

    fetch(urlServer+entryPoint+method+appId, {
      method: 'POST',
      body: JSON.stringify(apiKey),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        ClearApiKeys()
        GetApiKeys()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function UpdateApiKey () {
    let entryPoint = Constants.UrlsConstants.apiKeyEntryPoint
    fetch(urlServer+entryPoint + '/' + appId, {
      method: 'PUT',
      body: JSON.stringify(apiKey),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        ClearApiKeys()
        GetApiKeys()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function DeleteApiKey () {
    if (apiKey.id) {
      let entryPoint = Constants.UrlsConstants.apiKeyEntryPoint
      let method = Constants.MethodsWSConstants.API_KEY.DELETE_API_KEY + appId
      fetch(urlServer+entryPoint+method+'/'+apiKey.id, {
        method: 'DELETE',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(data => {
          dispatch(loaded('Error.Croutons.deleteSuccess'))
          ClearApiKeys()
          GetApiKeys()
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.deleteError'))
          }
        })
    }
  }

  return {
    FetchAuthorizations,
    ClearApiKeys,
    GetApiKeys,
    CreateApiKey,
    UpdateApiKey,
    DeleteApiKey,
  }
}
